import {toString, toList} from "../helpers/helpers";

const DEFAULT_MESSAGE = "Workbook is missing required headers or sheets, or may be corrupt.";

export interface MissingColumnInfo {
  sheetName: string;
  columnNames: string[];
}

export function missingColumnInfoFactory(json: any): MissingColumnInfo {
  return {
    sheetName: toString(json.sheetName),
    columnNames: toList(toString, json.columnNames),
  } as MissingColumnInfo;
}

export class WorkbookMissingColumnsError extends Error {
  name: string = "WorkbookMissingColumnsError";
  missingColumns: MissingColumnInfo[];
  missingSheets: string[];

  message: string;

  static check(obj: any): boolean {
    if (!obj) return false;

    return Object.prototype.hasOwnProperty.call(obj, "missingColumns") &&
      obj["missingColumns"] !== null &&
      obj["missingColumns"] !== undefined &&
      obj["missingColumns"] instanceof Array &&
      Object.prototype.hasOwnProperty.call(obj, "missingSheets") &&
      obj["missingSheets"] !== null &&
      obj["missingSheets"] !== undefined &&
      obj["missingSheets"] instanceof Array;
  }

  constructor(json) {
    super("");
    Object.setPrototypeOf(this, WorkbookMissingColumnsError.prototype);

    if (!WorkbookMissingColumnsError.check(json)) {
      throw new Error("Not a WorkbookMissingColumnsError");
    }

    this.missingSheets = toList(toString, json.missingSheets);
    this.missingColumns = toList(missingColumnInfoFactory, json.missingColumns);
    this.message = toString(json.message) || DEFAULT_MESSAGE;
  }

  get stack(): any {
    return [
      ...this.missingSheets.map(sheetName => `    Missing sheet "${sheetName}"`),
      ...this.missingColumns.map(({sheetName, columnNames}) => ([
        `    ${sheetName}:`,
        ...columnNames.map(column => `        ${column}`),
      ].join("\n"))),
    ].join("\n");
  }
}
